import { Card, CardHeader } from "@verde/compose-ui";
import { type FetchVerdePush, useFetchAllFieldInsight } from "@verde/entities";
import { AlertCircleIcon, OpenBookIcon, SendIcon } from "@verde/icons";
import { Alert, Skeleton } from "@verde/ui-core";
import SeuVerdeWidget from "components/seu-verde-widget";
import TemplateCard from "../components/template-card";

export default function Templates() {
  const { data, isLoading } = useFetchAllFieldInsight();
  return (
    <div className="grid grid-cols-12 items-start gap-4">
      <div className="col-span-3 grid items-start gap-4">
        <CardHeader
          classNames={{ base: "bg-neutral-light-pure rounded p-3" }}
          title="Verde Push"
          icon={<SendIcon className="-rotate-45" />}
          description="Assistente de Marketing da Verde que te auxilia na criação e envios de campanhas de marketing."
        />
        <SeuVerdeWidget mode="short" />
      </div>
      <div className="col-span-9 grid gap-4 bg-neutral-light-pure p-4 rounded">
        <CardHeader
          classNames={{ base: "p-0" }}
          title="Templates de campanhas"
          icon={<OpenBookIcon />}
          description="Encontre o template melhor se encaixa na sua campanha de marketing e envie ao seu produtor!"
        />
        {}
        {data?.length === 0 || !data ? (
          <Alert kind="warning" icon={<AlertCircleIcon />}>
            <p>
              Nenhum template foi definido ainda. Aguarde, em breve liberaremos!
            </p>
          </Alert>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 bg-neutral-light-1 p-3 gap-3 rounded">
            {isLoading ? (
              <>
                <Skeleton height={420} />
                <Skeleton height={420} />
                <Skeleton height={420} />
              </>
            ) : (
              data?.map((template, index) => (
                <TemplateCard
                  key={`advise-template-${index + 1}`}
                  advise={template}
                />
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}
